import React, { forwardRef, useMemo } from 'react';
import { Map, type MapProps, type MapRef } from '@vis.gl/react-maplibre';
import 'maplibre-gl/dist/maplibre-gl.css';
import { buildBasemapStyle, type BasemapId } from 'utils/maplibre';

export type { MapRef } from '@vis.gl/react-maplibre';

export interface MapViewProps extends Omit<MapProps, 'mapStyle'> {
  basemap?: BasemapId;
}

// Shared wrapper around react-maplibre's <Map>, replacing the boilerplate every
// view previously copy-pasted onto its own resium <Viewer> (hidden attribution,
// default raster basemap). Views needing satellite/neutral-road switching or
// custom overlays render through this and reach the underlying maplibregl.Map
// via `ref.current?.getMap()`.
const MapView = forwardRef<MapRef, MapViewProps>(function MapView(
  { basemap, style, children, ...mapProps },
  ref
) {
  const mapStyle = useMemo(() => buildBasemapStyle(basemap), [basemap]);

  return (
    <Map
      ref={ref}
      mapStyle={mapStyle}
      attributionControl={false}
      style={style ?? { width: '100%', height: '100%' }}
      {...mapProps}
    >
      {children}
    </Map>
  );
});

export default MapView;
